import { Mtds, CopyIcon } from 'prove-common'
import { AppVersionMeta } from '../../hooks/useAutoUpdater'
import { useState } from 'react'

type BuildInfoProps = {
  versionMeta: AppVersionMeta
}

const CopyButton = ({ value }: { value: string }) => {
  const [copied, setCopied] = useState(false)
  const handleCopy = async () => {
    if (!value) return
    await navigator.clipboard.writeText(value)
    setCopied(true)
  }
  return (
    <Mtds.Button
      key={copied ? 'copied' : 'default'}
      onClick={handleCopy}
      data-tooltip={copied ? 'Kopiert!' : 'Kopier til utklippstavle'}
      className='ml-2'
    >
      <CopyIcon />
    </Mtds.Button>
  )
}

export const BuildInfo = ({ versionMeta }: BuildInfoProps) => {
  const { commit, buildId } = versionMeta
  return (
    <Mtds.Details data-variant='card'>
      <Mtds.Details.Summary>Versjonsdetaljer</Mtds.Details.Summary>
      <Mtds.Table data-fixed data-border='none'>
        <tbody>
          <tr>
            <th>Commit</th>
            <td>
              {commit ?? '–'}
              {commit && <CopyButton value={commit} />}
            </td>
          </tr>
          <tr>
            <th>BuildId</th>
            <td>
              {buildId ?? '–'}
              {buildId && <CopyButton value={buildId} />}
            </td>
          </tr>
        </tbody>
      </Mtds.Table>
    </Mtds.Details>
  )
}
